import { Button } from "@/components/ui/button";
import { FrAvatar } from "../components/fr-avatar.js";
import { ArrowUpRight } from "./approved-icons.js";

export function ApprovedAvatar({
  name,
  size = 54,
  participantId,
  accountId,
  self,
}: {
  name: string;
  size?: number;
  participantId?: string | null | undefined;
  accountId?: string | null | undefined;
  self?: boolean | undefined;
}): React.JSX.Element {
  return (
    <FrAvatar
      name={name}
      size={size}
      participantId={participantId}
      accountId={accountId}
      self={self}
    />
  );
}

export function ApprovedHeading({
  title,
  action,
  onAction,
  onTitleClick,
  children,
}: {
  title: string;
  action?: string;
  onAction?(): void;
  onTitleClick?(): void;
  children?: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="fr-approved-heading">
      <h2>
        {onTitleClick ? (
          <button className="fr-section-link" onClick={onTitleClick}>
            {title}
          </button>
        ) : (
          title
        )}
      </h2>
      {children}
      {action ? (
        <Button variant="link" onClick={onAction}>
          {action}
          <ArrowUpRight size={14} />
        </Button>
      ) : null}
    </div>
  );
}
